export enum GlobalQueryKeys {
  HEADER = 'global.header',
  PARTIAL_HEADER = 'global.partialHeader',
  STICKY_NAV = 'global.stickyNav',
  DIRECT_SHIPPING_ELIGIBILITY = 'global.directShippingEligibility',
  SEARCH_POPULAR_BRANDS = 'search.popularBrands',
  SEARCH_SUGGESTIONS = 'search.suggestions',

  SIZE_GUIDE = 'global.sizeGuide',

  PAYMENT_LOGOS = 'global.paymentLogos',

  PRODUCT_CONDITION_DETAILS = 'global.productConditionDetails',
  PRODUCT_SALES_CONDITION = 'global.productSalesCondition',

  INITIAL_REQUEST_URL = 'global.initialRequestUrl',
  WELCOME_VOUCHER = 'global.welcomeVoucher',
  PAGE_TYPE = 'global.pageType',
}

export enum ProductPageQueryKeys {
  SIMILAR_PRODUCTS = 'pdp.similarProducts',
  CHAT_ELIGIBLE = 'pdp.chatEligible',
  PRODUCT_SHIPPING = 'pdp.productShipping',
  SELLER_STATS = 'pdp.sellerStats',
}

export enum UserQueryKeys {
  USER = 'user.user',
  USER_SIZES = 'user.userSizes',
  FOLLOWED_USERS = 'user.followedUsers',
  LIKED_PRODUCTS = 'user.likedProducts',
}

export enum UserMutationKeys {
  FOLLOW_USER = 'user.followUser',
  UNFOLLOW_USER = 'user.unfollowUser',
}

export enum NotificationQueryKeys {
  NOTIFICATION_FEED_ACTIVITY = 'notification.feed.activity',
  NOTIFICATION_FEED_MESSAGES = 'notification.feed.messages',
  NOTIFICATION_FEED_COUNTER = 'notification.feed.counter',
  NOTIFICATION_FEED_COUNTER_V2 = 'notification.feed.counter.v2',
  NOTIFICATION_FEED_UPDATES_V2 = 'notification.feed.updates.v2',
  NOTIFICATION_FEED_MESSAGES_V2 = 'notification.feed.messages.v2',
  NOTIFICATION_FEED_RESET_COUNTER = 'notification.feed.reset.counter',
}

export enum ChatPageMessageListQueryKeys {
  CHAT_PAGE_MSG_LIST = 'chatPage.messageList',
  CHAT_PAGE_CHAT_HISTORY = 'chatPage.chatHistory',
}

export enum FooterQueryKeys {
  FOOTER_DATA = 'footer.data',
}

export enum CartQueryKeys {
  CART_ORDERS = 'cart.orders',
  CART_CONFIGS = 'cart.configs',
}

export enum CartMutationKeys {
  ADD_TO_CART = 'cart.addFromCart',
  REMOVE_FROM_CART = 'cart.removeFromCart',
}

export enum ConsignmentMutationKeys {
  COLLECT_MY_ITEM = 'consignment.recoverItem',
}

export enum ProductCatalogQueryKeys {
  SEARCH_PREFERENCE_OPTION = 'plp.searchPreferenceOptions',
  GET_PRODUCT_CATALOG = 'plp.getProductCatalog',
  GET_PLP_INNER_FEED = 'plp.getPlpInnerFeed',
}

export enum ProductDiscussionKeys {
  INITIAL_PRODUCT_DISCUSSION_COMMENTS = 'productDiscussion.initialProductDiscussionComments',
  PRODUCT_DISCUSSION_COMMENTS = 'productDiscussion.productDiscussionComments',
  ADD_PRODUCT_DISCUSSION_COMMENT = 'productDiscussion.addComment',
}

export enum NegotiationKeys {
  ACTIVE_NEGOTIATION = 'negotiation.active',
  NEGOTIATIONS_BY_PRODUCT = 'negotiation.byProduct',
  NEGOTIATION_INITIAL_DATA = 'negotiation.initialData',
  NEGOTIATION_YOU_EARN = 'negotiation.youEarn',
  NEGOTIATION_BUYING_OFFERS = 'negotiation.buyingOffers',
  NEGOTIATION_SELLING_OFFERS_PRODUCT = 'negotiation.sellingOffersProduct',
  NEGOTIATION_SELLING_OFFERS_PRODUCTS = 'negotiation.sellingOffersProducts',
  NEGOTIATION_SELLING_OFFERS_NEGOTIATIONS = 'negotiation.sellingOffersNegotiations',
  NEGOTIATION_LISTINGS_PRODUCTS = 'negotiation.listingsProducts',
  NEGOTIATION_LISTINGS_ITEMS_TO_SHIP = 'negotiation.listingsItemsToShip',
  NEGOTIATION_LISTINGS_MARK_ITEM_AS_SHIPPED = 'negotiation.markItemAsShipped',
  NEGOTIATION_OFFERSETTINGS_PRODUCTS = 'negotiation.offerSettingsProducts',
}

export enum CTAProductQueryKeys {
  NEGOTIATION = 'CTAproduct.neogtiation',
}

export enum TranslationMutationKeys {
  TRANSLATE = 'productDiscussion.translate',
}

export enum CatalogManagementQueryKeys {
  CATALOG_LIST = 'catalogManagement.fetchCatalogList',
  CATALOG_PRODUCT = 'catalogManagement.fetchCatalogProduct',
  FILTERS = 'catalogManagement.fetchFilters',
}

export enum MySizesQueryKeys {
  SEARCH_PREFERENCE_OPTION = 'mysizes.searchPreferenceOptions',
}

export enum AlertsCatalogQueryKeys {
  FETCH_DATA = 'get.alertsNewInAndProductSearch',
  CHECK_EXISTENCE = 'check.alertsExistence',
}

export enum ListContextQueryKeys {
  LIST_MODELS = 'depositService.listModels',
  LIST_BRANDS = 'depositService.listBrands',
  LIST_CATALOG = 'depositService.listCatalog',
}

export enum PricingCalculatorQueryKeys {
  PRICE_ESTIMATE = 'depositService.getPriceEstimate',
}

export enum JournalCatagoryKeys {
  GET_CATEGORIES = 'JournalMainService.getCategories',
  GET_ARTICLES_BY_CATEGORY = 'JournalMainService.getArticlesByCategory',
}

export enum ActiveDealQueryKeys {
  ACTIVE_DEAL = 'activeDeal.activeDeal',
}

export enum LocalizationQueryKeys {
  LOCALIZATION = 'localization.localization',
}

export enum MarketingFiltersQueryKeys {
  MARKETING_FILTERS = 'marketingFilters.marketingFilters',
}

export enum ProductPdpPageQueryKeys {
  GET_PDP_PRODUCT = 'productPdp.getPdpProduct',
}

export enum CatalogPageQuerykeys {
  GET_CATALOG_METADATA = 'catalog.getCatalogPageMetadata',
  GET_GUIDED_SEARCH = 'catalog.getGuidedSearch',
}

export enum BreadcrumbsQueryKeys {
  BREADCRUMBS = 'breadcrumbs.breadcrumbs',
}

export enum OrdersSalesQueryKeys {
  ORDERS = 'ordersSales.orders',
  SALES = 'ordersSales.sales',
  TIMELINE = 'ordersSales.timeline',
  SEARCH_SALES = 'ordersSales.searchSales',
  PRODUCT_SHIPPING = 'ordersSales.productShipping',
  GET_SHIPPING_LABEL = 'ordersSales.shippingLabel',
  GET_SHIPPING_ADDRESS = 'ordersSales.shippingAddress',
  GET_DROP_OFF_POINTS = 'ordersSales.getDropOffPoints',
  AWAITING_SHIP_PRODUCTS = 'ordersSales.awaitingShipProducts',
}

export enum FavoritesQueryKeys {
  FAVORITES_PRODUCTS = 'favorites.getProducts',
  FAVORITES_CMS_PRODUCTS = 'favorites.getCMSProducts',
  FAVORITES_CMS_DATA = 'favorites.getCMSData',
}

export enum RecentSearchesQueryKeys {
  RECENT_SEARCHES_COUNT = 'recentSearches.recentSearchesCount',
}

export enum OrderReportIssueQueryKeys {
  UPLOAD_IMAGE = 'reportIssue.uploadImage',
  SUBMIT_RETURN_FORM = 'reportIssue.submitReturnForm',
}

export enum OrderCallbackQueryKeys {
  SUBMIT_FORM = 'callback.submitForm',
}

export enum PayoneerKeys {
  GET_PAYONEER_SUPPORTED_BANKS = 'payoneer.getPayoneerSupportedBanks',
}

export enum KycQueryKeys {
  GET_CUSTOMER = 'kyc.getCustomer',
  GET_TRANSFER_METHOD = 'kyc.getTransferMethod',
  GET_KYC_PERSONA_INQUIRY = 'kyc.persona.inquiry',
}

export enum UserAuthenticationKeys {
  UPDATE_PASSWORD = 'userAuthentication.updatePassword',
}

export enum ReconciliationQueryKeys {
  REQUEST = 'reconciliation.request',
  VERIFY = 'reconciliation.verify',
}

export enum ListingQueryKeys {
  PRODUCT_DRAFTS_LIST = 'listing.productDraftsList',
}

export enum AiListingQueryKeys {
  DRAFT_DETAILS = 'aiListing.draftDetails',
  CATEGORIES = 'aiListing.categories',
  BRANDS = 'aiListing.brands',
  MODELS = 'aiListing.models',
  SHIPPING_ADDRESS = 'aiListing.shippingAddress',
  PRICE_DETAILS = 'aiListing.priceDetails',
  PRICE_RECOMMENDATION = 'aiListing.priceRecommendation',
  PRICE_ZONE = 'aiListing.priceZone',
  PRODUCT_DRAFT_PHOTOS = 'aiListing.productDraftPhotos',
  AI_PRODUCT_DRAFT_PHOTOS = 'aiListing.aiProductDraftPhotos',
}

export enum AiListingMutationKeys {
  CREATE_DRAFT = 'aiListing.createDraft',
  UPDATE_DRAFT = 'aiListing.updateDraft',
  SUBMIT_DRAFT = 'aiListing.submitDraft',
  UPLOAD_PHOTOS = 'aiListing.uploadPhotos',
  GENERATE_DESCRIPTION = 'aiListing.generateDescription',
  REORDER_PHOTOS = 'aiListing.reorderPhotos',
  DELETE_PHOTO = 'aiListing.deletePhoto',
  UPLOAD_PRODUCT_DRAFT_PHOTOS = 'aiListing.uploadProductDraftPhotos',
  REORDER_PRODUCT_DRAFT_PHOTOS = 'aiListing.reorderProductDraftPhotos',
  DELETE_PRODUCT_DRAFT_PHOTO = 'aiListing.deleteProductDraftPhoto',
}

export enum ListingMutationQueryKeys {
  REMOVE_FROM_SALE = 'listing.removeFromCart',
  REASONS_TO_CANCEL_MY_SALE = 'listing.reasonsToCancelMySale',
  CANCEL_MY_SALE = 'listing.cancelMySale',
}

export enum SellerInformationKeys {
  GET_BILLING_ADDRESS = 'SellerInfoService.getUserBillingAddress',
  GET_TAX_INFORMATION = 'SellerInfoService.getUserTaxInformation',
  UPDATE_TAX_INFORMATION = 'SellerInfoService.updateUserTaxInformation',
  SAVE_TAX_INFORMATION = 'SellerInfoService.saveUserTaxInformation',
}

export enum ProfileQueryKeys {
  PROFILE_USER = 'profile.getProfile',
  PROFILE_MY_ITEMS_FOR_SALE = 'profile.myItemsForSale',
  PROFILE_COMMUNITY_FOLLOWING = 'profile.community.following',
  PROFILE_COMMUNITY_FOLLOWERS = 'profile.community.followers',
}

export enum ProductFeedQueryKeys {
  PDP_PRODUCT_FEEDS = 'productFeed.pdpProductFeeds',
  SEM_FEED = 'productFeed.semFeed',
}

export enum PriceDropRecommendedPriceQueryKeys {
  PRICE_DROP_RECOMMENDED = 'priceDrop.recommendedPrice',
  PRICE_DROP_ZONE = 'priceDrop.priceZone',
  PRICE_DETAILS = 'priceDrop.priceDetails',
  DROP_PRICE = 'priceDrop.dropPrice',
}

export enum QualityControlReportQueryKeys {
  GET_QC_REPORT = 'qualityControlReport.getQcReport',
}

export enum FeatureFlagsKeys {
  SEM_LANDING_PAGE_RECOMMENDATION_BLADES = 'pdp.semLandingPage.recommendationBlades',
}

export enum AccountPaymentsQueryKeys {
  PAYMENT_CARDS = 'accountPayments.paymentCards',
}

export enum AuthenticationAskSellerQueryKeys {
  PRODUCT_AUTH_REQUEST_INFO = 'productAuthRequest.productAuthRequestInfo',
  PURCHASE_PLACES = 'productAuthRequest.purchasePlaces',
  SUBMIT_ASK_SELLER_FORM = 'productAuthRequest.submitAskSellerForm',
}

export enum VcAuthMutationKeys {
  CHECK_EMAIL = 'vcAuth.checkEmail',
}
